import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Card,
  message,
  Modal,
  Input,
  Tag,
  Typography,
  Row,
  Col,
  Spin,
} from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import axios from "axios";
import OwnersForm from "./ownerForm";

const { Search } = Input;
const { Title } = Typography;

const Owners = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [ownersData, setOwnersData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/owners");
      setOwnersData(response.data);
      setFilteredData(response.data);
    } catch (error) {
      message.error("Unable to load data!");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const lowerSearch = value.toLowerCase();
    const filtered = ownersData.filter((owner) =>
      Object.keys(owner).some((key) =>
        String(owner[key]).toLowerCase().includes(lowerSearch)
      )
    );
    setFilteredData(filtered);
  };

  const highlightText = (text, searchText) => {
    if (!searchText) return text;
    const regex = new RegExp(`(${searchText})`, "gi");
    const parts = text.toString().split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <span
          key={index}
          style={{
            backgroundColor: "#fffb8f",
            fontWeight: "bold",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const handleEditOwner = (record) => {
    setFormData(record);
    setModalVisible(true);
  };

  const ownersColumns = [
    {
      title: <span style={{ fontWeight: "bold" }}>Name</span>,
      dataIndex: "name",
      key: "name",
      render: (text) => highlightText(text, searchText),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Contact</span>,
      dataIndex: "contact",
      key: "contact",
      render: (text) => highlightText(text, searchText),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Email</span>,
      dataIndex: "email",
      key: "email",
      render: (text) => highlightText(text, searchText),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Address</span>,
      dataIndex: "address",
      key: "address",
      render: (text) => highlightText(text, searchText),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Bank Info</span>,
      dataIndex: "bankInfo",
      key: "bankInfo",
      render: (text) => highlightText(text, searchText),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Status</span>,
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const color =
          status === "Active"
            ? "green"
            : status === "Pending"
            ? "orange"
            : "green";
        return (
          <Tag color={color} style={{ fontWeight: "bold" }}>
            {status ? status.toUpperCase() : "Active"}
          </Tag>
        );
      },
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Actions</span>,
      key: "actions",
      render: (_, record) => (
        <>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEditOwner(record)}
            style={{ color: "#0c8c49", marginRight: 8 }}
          >
            Edit
          </Button>
          <Button type="link">
            <NavLink
              to={`/ownerDetails/${record.id}`}
              style={{ color: "#0c8c49" }}
            >
              <InfoCircleOutlined /> Details
            </NavLink>
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card
        style={{
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderTop: "5px solid #0c8c49",
        }}
      >
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          Owners
        </Title>
        <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
          <Col span={18}>
            <Search
              placeholder="Search Owners"
              allowClear
              enterButton={<SearchOutlined />}
              onSearch={handleSearch}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: "60%" }}
            />
          </Col>
          <Col span={6} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setModalVisible(true)}
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
              }}
            >
              Add Owner
            </Button>
          </Col>
        </Row>
        {loading ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Spin size="large" />
          </div>
        ) : (
          <Table
            columns={ownersColumns}
            dataSource={filteredData}
            rowKey="id"
            pagination={{ pageSize: 5 }}
            bordered
          />
        )}
      </Card>

      <Modal
        title={formData.id ? "Edit Owner" : "Add Owner"}
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        centered
        width="50%"
        style={{ borderRadius: "10px" }}
        bodyStyle={{
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <OwnersForm
          formData={formData}
          setFormData={setFormData}
          closeModal={() => setModalVisible(false)}
          refetchData={fetchData}
        />
      </Modal>
    </div>
  );
};

export default Owners;
